import React, {Component, createRef} from "react"
import {connect} from "react-redux"
import {Button, Col, Icon, Input, Row, Spin} from "antd"
import axios from "axios"
import {AuthHeader} from "configs/auth.token"
import {error_manager} from "helper/error_manager"
import {getStateAwareUrl} from "utils/utils"
import HistoryLink from "component/common/HistoryLink"
import {get, post} from "helper/request"

import "asset/style/patient_folder.css"
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DangerousIcon from '@mui/icons-material/Dangerous';
import {getFolderEndpoint, openFolderEndpoint} from "utils/endpoint_utils"


const FolderNameStatus = {
    LOADING: "LOADING",
    VALID: "VALID",
    INVALID: "INVALID",
    NONE: "NONE"
}

class AddPatientFolder extends Component {
    constructor(props) {
        super(props)

        this.state = {
            folderName: "",
            folderNameStatus: FolderNameStatus.NONE,
        }
        this.tagSelectRef = createRef()
    }

    changeFolderName = (e) => {
        const folderName = e?.target?.value
        this.setState({ folderName, folderNameStatus: FolderNameStatus.LOADING })

        if (this.validateFolderNameTimeout !== null) {
            clearTimeout(this.validateFolderNameTimeout)
            this.validateFolderNameTimeoutId = null
        }

        this.validateFolderNameTimeoutId = setTimeout(() => {
            this.validateFolderName(folderName)
        }, 500)
    }

    validateFolderName = (folder_name) => {
        const url = "/api/patient_folder/"
        const params = { folder_name }

        axios.get(getStateAwareUrl(url), {params, "headers": {"Authorization": AuthHeader()}})
            .then(data => this.setState({folderNameStatus: data.count > 0 ? FolderNameStatus.INVALID : FolderNameStatus.VALID}))
            .catch(err => error_manager("", err))
    }

    createFolder = () => {
        const allOptions = this.tagSelectRef.current.options
        const selectedOptions = []

        for (let idx = 0; idx < allOptions.length; idx++) {
            const { value, selected } = allOptions[idx]
            if (!selected) continue
            selectedOptions.push(value)
        }

        const data = {
            folder_name: this.state.folderName,
            tags: selectedOptions,
        }

        const url = "/api/patient_folder/"

        post(url, data)
            .then(() => openFolderEndpoint())
            .catch(err => {
                error_manager("unable to create folder", err.message)
                console.error(err.message)
            })
    }

    renderFolderNameStatus = () => {
        switch (this.state.folderNameStatus) {
            case FolderNameStatus.VALID:
                return <CheckCircleIcon style={{ color: "green", paddingTop: "5px" }} />

            case FolderNameStatus.INVALID:
                return <DangerousIcon style={{ color: "red", paddingTop: "5px" }} />

            case FolderNameStatus.LOADING:
                return (
                    <Spin
                        indicator={(
                            <Icon type="loading" style={{ paddingTop: "5px" }} spin />
                        )}
                    />
                )

            case FolderNameStatus.NONE:
            default:
                return <></>
        }
    }

    historyLinks = [
        {
            label: "Folders",
            link: getFolderEndpoint()
        },
        {
            label: "Add Folder",
            link: "/addpatientfolder/"
        }
    ]

    render() {
        return (
            <Row>
                <div className="history-link-wrapper">
                    <HistoryLink links={this.historyLinks} />
                </div>

                <Col span={24} offset={0} className="all-slides">
                    <div className="heading-style main-heading-style">
                        <b>Create Folder</b>
                    </div>
                    <div>
                        <Row>
                            <Col offset={2} pull={1}>
                                <div>
                                    <Row className="add-case-row">
                                        <Col span={5} className="add-case-row-header">
                                            <b>Folder Name *</b>
                                        </Col>
                                        <Col span={6}>
                                            <Input
                                                className="input-field-add-case"
                                                placeholder="Current Folder Name"
                                                value={this.state.folderName}
                                                onChange={this.changeFolderName}
                                            />
                                        </Col>
                                        <Col span={1}>
                                            {this.renderFolderNameStatus()}
                                        </Col>
                                    </Row>
                                    <Row className="add-case-row">
                                        <Col span={5} className="add-case-row-header">
                                            <b>Tags</b>
                                        </Col>
                                        <Col span={8} className>
                                            <PatientFolderTagsSelect selectRef={this.tagSelectRef} />
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </div>

                    <div className="submit-row-add-case" style={{ marginBottom: "0px" }}>
                        <Button type="primary" onClick={this.createFolder} disabled={this.state.folderNameStatus !== FolderNameStatus.VALID}>
                            Save
                        </Button>
                    </div>
                </Col>
            </Row>
        )
    }
}

const mapStateToProps = (state) => ({

})

export default connect(mapStateToProps)(AddPatientFolder)


class PatientFolderTagsSelect extends Component {
    constructor(props) {
        super(props)

        this.state = {
            allTags: []
        }
    }

    componentDidMount() {
        this.fetchAllTags()
    }

    fetchAllTags = () => {
        const url = "/api/patient_folder_tag/"
        get(url).then(data => this.setState({ "allTags": data.map(({ name }) => name) }))
    }

    render() {
        return (
            <select multiple className="tag-multi-select" ref={this.props.selectRef}>
                {this.state.allTags?.map(tag => (
                    <option value={tag}>
                        {tag}
                    </option>
                ))}
            </select>
        )
    }
}